export default __webpack_public_path__ + "static/media/Path2262.e3ad6bd7.svg";